import { collection, getDocs, query, where, doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

// Get all shops
export const getAllShops = async () => {
  const snapshot = await getDocs(collection(db, "shops"));
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Get a single shop by ID
export const getShopById = async (shopId) => {
  const ref = doc(db, "shops", shopId);
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
};

// ✅ Get a single shop by slug
export const getShopBySlug = async (slug) => {
  const q = query(collection(db, "shops"), where("slug", "==", slug));
  const snapshot = await getDocs(q);

  if (snapshot.empty) return null;

  const docSnap = snapshot.docs[0];
  return { id: docSnap.id, ...docSnap.data() };
};
